import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterArticle_template} from "./filterArticle_template";
import {
    filterSingleDate_template
} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSingleDate_template";

declare var ko: any;

export class pollsEdit_template extends vnTemplate{

    protected filterDiscussionArticle: filterArticle_template;
    public datePicker: filterSingleDate_template;

    protected getTemplateHtml(): string{
        return `
            <div class="w-form w-form-large form-poll">
               <div class="form-header">
                    <input id="poll-id" data-bind="value: id" type="hidden">
                    <h3 class="form-title icon i-poll" data-bind="text: id() != null ? 'Edit Poll' : 'Add Poll'"></h3>
                    <button data-bind="event: { click: onClickCancel }" class="close-button icon i-close-2" type="button"></button>
                </div>
    
                <div class="w-form-body">
                    <div class="form-body full-width" style="border-bottom: 0">
                        <strong class="form-sub-title" style="margin-bottom: 0">Info</strong>
                    </div>
                    
               </div>
               
               <div class="w-form-body">
               
                    <div class="form-body">
                       
                       <div class="form-group">
                            <label for="title" class="form-label">Name</label>
                            <input id="title" data-bind="value: name, valueUpdate: 'keyup'" type="text" class="input-text">
                        </div>
                                               
                    </div>
                    
                    <div class="form-body">
                                        
                         <div id="datePicker" class="form-group row align-left">
                         
                            <label class="form-label" for="singleDatePicker" style="">Close Date</label>
                            <div style="">
                            ` + this.datePicker.getHtmlBuild() + `
                            </div>
                        </div>
                    
                    </div>
                  
                    
               </div>
               
               <div class="w-form-body">
                    <div class="form-body full-width" style="border-bottom: 0;padding-top: 1rem">
                        <strong class="form-sub-title" style="margin-bottom: 0">Content</strong>
                    </div>
                    
               </div>
               
               <div class="w-form-body">
                    <div class="form-body">

                         <div class="form-group">
                            <label for="title" class="form-label">Question</label>
                            <!--<input id="title" data-bind="value: description, valueUpdate: 'keyup'" type="text" class="input-text">-->
                            <textarea id="title" style="height: 12rem" data-bind="value: description, valueUpdate: 'keyup'" type="text" class="input-text"></textarea>
                        </div>
                        
                         <div class="form-group inside-label">
                            <label class="form-label" for="idArticle" >Discussion Article</label>
                            ` + this.filterDiscussionArticle.getHtmlBuild() + `
                        </div>
                           
                    </div>  
                     
                    <div class="form-body">
                        
                        <div class="form-group row">
                            <label for="type" class="form-label">Type</label>
                            <select name="" id="" data-bind="value: type">
                                <option value="single-select">Single Select</option>
                                <option value="multi-select">Multi Select</option>
                            </select>
                        </div>
                        
                        <div class="form-group">
                            <hr />
                        </div>
                        
                        <div class="form-group">
                            <label class="form-label">Options</label>
                            <div class="row">
                                <input type="text" class="input-text" style="flex:1;margin-left: 0" data-bind="value: choiceLabel, valueUpdate: 'keyup'">
                                <button id="add_choice" class="btn border icon only-icon i-add" data-bind="event: {click: onClickAddChoice}, disable: choiceLabel() == ''" type="button"></button>
                            </div>
                         </div>
                         
                         
                         <!--
                         <div class="inside-label">
                            <label class="form-label">Text</label>
                            <input type="text" class="input-text" data-bind="value: choiceText">
                         </div>
                         -->    
                          
                         <div id="spec_section" class="choices" >
                            <div id="spec_section_list" data-bind="foreach: choices">
                              <div class="form-group row">
                        
                                  <span  class="form-label"  type="text" data-bind="text: choiceLabel"></span>
                                  <!--
                                  <div>
                                        <input class="input-text" type="text" data-bind="value: choiceText">
                                  </div>
                                  -->
                                  <!-- ko if: $data.canDelete -->
                                  <button type="button" class="btn icon only-icon i-close" data-bind="event: {click: $parent.onClickDeleteChoice }"></button>
                                  <!-- /ko -->
                              </div>
                           </div>    
                         </div>
                        
                     </div>
                </div>
                 
                 <div class="form-footer">
                    <button data-bind="event: { click: onClickCancel }" class="btn" type="button">Cancel</button>
                    <button data-bind="event: { click: onClickSave }" class="btn highlight" type="button">Save</button>
                </div>
               </div>
            `;
    }

    protected initPartial(): void {

        this.filterDiscussionArticle = new filterArticle_template("filterDiscussionArticle", this.getTemplateViewModel(), this.caller);
        this.datePicker = new filterSingleDate_template("filterDate", this.getTemplateViewModel(), this.caller);
        this.datePicker.toggleClearButton(true);
        this.datePicker.setMinutesInterval(1);
    }

    public buildDatePickerCalendar() {

        this.datePicker.buildCalendar();
    }

    protected getTemplateName(): string{
        return "pollsEdit-template";
    }

    protected getMainElementType(): string{
        return "div";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;
        return  {
            id: ko.observable()
            ,name: ko.observable("")
            ,choiceLabel: ko.observable("")
            ,choiceText: ko.observable("")
            ,description: ko.observable("")
            ,type: ko.observable("")
            ,idDiscussionArticle: ko.observable()
            ,choices: ko.observableArray([])
            ,onClickCancel: function (data, event) { huit_neuf_this.onClickCancel(data) }
            ,onClickSave: function (data, event) { huit_neuf_this.onClickSave() }
            ,onClickAddChoice: function (value, data, event) { huit_neuf_this.onClickAddChoice(); }
            ,onClickDeleteChoice: function (data, event) { huit_neuf_this.onClickDeleteChoice(data); }
            ,onClickModifyDatePicker: function (data, event){ huit_neuf_this.clearDateClosed(data);}
            ,dateClosed: ko.observable()
        };
    }

    public getViewModelForRequest(){
        let huit_neuf_this = this;

        return {
            id: this.getTemplateViewModel().id()
            ,name: this.getTemplateViewModel().name()
            ,description: this.getTemplateViewModel().description()
            ,type: this.getTemplateViewModel().type()
            ,idDiscussionArticle: this.getTemplateViewModel().filterDiscussionArticle.idArticle
            ,choices: this.getTemplateViewModel().choices()
            ,dateClosed: this.getTemplateViewModel().filterDate.singleDatePicker()
        };
    }

    public onClickSave(){
        this.caller.savePoll();
    }

    public onClickCancel(data){
        this.caller.cancel(data.id());
    }

    public setDiscussionArticle(article) {

        this.filterDiscussionArticle.getTemplateViewModel().article(article.title)
        this.filterDiscussionArticle.getTemplateViewModel().articleObj(article)
        this.filterDiscussionArticle.getTemplateViewModel().idArticle(article.id);
    }

    public setArticlesFilter(articles) {

        this.getTemplateViewModel().filterDiscussionArticle.articles(articles);
    }

    protected onClickAddChoice() {

        let choices = this.getTemplateViewModel().choices();

        let id = 1;
        for(let choice of choices){
            if (choice.id >= id){
                id = choice.id + 1;
            }
        }

        choices.push({
            id: id,
            isAdded: true,
            choiceLabel: this.getTemplateViewModel().choiceLabel(),
            choiceText: this.getTemplateViewModel().choiceLabel(),
            votes: 0,
            canDelete: true,
        });

        this.getTemplateViewModel().choices(choices);
        this.getTemplateViewModel().choiceLabel('');
        this.getTemplateViewModel().choiceText('');
    }

    protected onClickDeleteChoice(data) {

        let index = this.getTemplateViewModel().choices().findIndex(element => element == data);
        if (index > -1) {
            this.getTemplateViewModel().choices.splice(index, 1);
        }
    }

    public setId(id){
        this.getTemplateViewModel().id(id);
    }

    public setName(name){
        this.getTemplateViewModel().name(name);
    }

    public setDescription(description){
        this.getTemplateViewModel().description(description);
    }

    public setType(type){
        this.getTemplateViewModel().type(type);
    }

    public setChoices(choices){
        this.getTemplateViewModel().choices(choices);
    }

    public setDateClosed(dateClosed){

        this.datePicker.setDate(dateClosed);
    }

    public clearDateClosed(data){

        //If set to Active (true) clear close date
        if (data) {

            this.datePicker.setDate(null);
        }
    }

}


// WEBPACK FOOTER //
// ./js/components/templates/pollsEdit_template.ts